const OPEN_TICKET_BLOCKED_VENDOR_CODES = new Set([
    "3dlynx",
    "88dent",
    "3pguide",
    "3p",
    "idievolution",
    "oxy",
    "medentis",
    "jdental",
    "jdentalcare",
    "prodent",
    "newancorvisstyle",
    "new ancorvis",
    "itakad",
    "itaka",
    "sweden-martina",
    "sweden&martina",
    "bredent",
    "biomax",
    "iess",
    "ipd",
    "btk3d",
]);

const REMOTE_SUPPORT_BLOCKED_VENDOR_CODES = new Set(["itakad", "itaka", "bredent"]);

function normalizeVendorCode(vendor?: string | null) {
    return vendor?.trim().toLowerCase() ?? "";
}

export function isOpenTicketBlockedVendor(vendor?: string | null) {
    return OPEN_TICKET_BLOCKED_VENDOR_CODES.has(normalizeVendorCode(vendor));
}

export function isRemoteSupportBlockedVendor(vendor?: string | null) {
    return REMOTE_SUPPORT_BLOCKED_VENDOR_CODES.has(normalizeVendorCode(vendor));
}
